(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function($) {
        Site.run();

        if (window.formswitcher == undefined) return;


       // console.log('in formswitcher');
        $(document).on('change','[data-formswitcher="formswitcher"]', function(e){
            var parent = $(this).closest('form');

            var value = $(this).val();

            parent.find('[data-type="formswitch"]').hide();

            for (var index in window.formswitcher[value]){

                parent.find('[data-field="'+ window.formswitcher[value][index] +'"]').show();
            }

        });

        $('[data-formswitcher="formswitcher"]').trigger('change');

    });

})(document, window, jQuery);